import { createElement as rc } from 'react';
import PropTypes from 'prop-types';
import { View, styled, fromTheme } from 'lib_ui-primitives';

const LeftAlign = styled(View)`
    justify-content: flex-start;
    flex-grow: 1;
    background-color: ${({ darkenBackground }) =>
        darkenBackground ? fromTheme('layout', 'backgroundColorDarker') : 'transparent'};
    margin-bottom: ${({ darkenBackground }) =>
        darkenBackground ? fromTheme('form', 'sectionGap') : 0};
`;

function LeftAlignLayout(props) {
    if (props == null) return null;
    const { id, title: name, hNode, children, ...otherProps } = props;
    const darkenBackground = /true/i.test(hNode?.darkenBackground);
    return rc(LeftAlign, { name, id, darkenBackground, ...otherProps }, children);
}

LeftAlignLayout.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.array,
    hNode: PropTypes.object.isRequired
};

export default LeftAlignLayout;
